import PropTypes from 'prop-types'
import React from 'react'

import FormGroup from './FormGroup'

import ValidationInfo from './ValidationInfo'
import ValidationText from './ValidationText'

const SelectInput = ({
  name,
  note,
  label,
  options = [],
  value,
  onChange,
  size = 8,
  className = '',
  info,
  helpText,
  required,
  disabled,
  readOnly,
  isValid
}) => {

  const select = (
    <select
      className="form-control"
      id={name}
      name={name}
      value={value}
      required={required}
      disabled={disabled}
      readOnly={readOnly}
    >
      {
        options.map((option) => {
          const val = option.value || option.id
          if (!val) {
            console.error(`Warning: No value for SelectInput option for input named \`${name}\`. Specify either a value or an id property!`)
          }
          return (
            <option
              value={val}
              key={`${name}-select-input-value-${val}`}
            >
              {option.title}
            </option>
          )
        })
      }
    </select>
  )

  return (
    <FormGroup
      label={label}
      name={name}
      info={info}
      note={note}
      onChange={onChange}
    >
      <div className={`col-xs-${size} ${className}`}>

        {select}

        {
          helpText
            ? <div className="help-block">{helpText}</div>
            : null
        }

        <ValidationText isValid={isValid}>
          <ValidationInfo isValid={isValid} />
        </ValidationText>
      </div>
    </FormGroup>
  )

}

SelectInput.propTypes = {
  className: PropTypes.string,
  disabled: PropTypes.bool,
  helpText: PropTypes.string,
  info: PropTypes.string,
  isValid: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.shape({
      errors: PropTypes.object,
      valid: PropTypes.bool
    })
  ]),
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  note: PropTypes.string,
  onChange: PropTypes.func,
  options: PropTypes.array.isRequired,
  readOnly: PropTypes.bool,
  required: PropTypes.bool,
  size: PropTypes.number,
  value: PropTypes.string,
}

export { SelectInput as default }



// WEBPACK FOOTER //
// ./src/shared/components/SelectInput.js